export default __webpack_public_path__ + "static/media/nugs.8ae01fc1.png";